import { trim } from 'lodash';

export const firstCharIsNotSpecialChar = (str) => {
  return RegExp(/^[a-zA-Z0-9](?!.*?[^\n a-zA-Z0-9:./\-&$%_#@(){}\\]).*?$/).test(
    str
  );
};

export const checkIfHasAllowedCharacters = (str) => {
  return RegExp(/^[ A-Za-z0-9:./\-&$#%_@(){}\\]*$/).test(str);
};

export const checkIfHasAlphaNumeric = (str) => {
  return RegExp(/[A-Za-z0-9]/).test(str);
};

export const stringOptimumLength = (str, min, max) => {
  if (str && str.length >= min && str.length <= max) {
    return true;
  }

  return false;
};

export const trimObjectValues = (obj) => {
  let newObj = {};
  for (const property in obj) {
    newObj[property] = trim(obj[property]);
  }
  return newObj;
};
